module.exports = __webpack_public_path__ + "static/media/witch-host.f91fb10f.gif";